import { Box, Button, Stack, SvgIcon, Typography, useTheme } from '@mui/material';

import { Plus, SearchSm } from '../../assets';
import CustomPagination from '../../components/forms/Pagination';
import { useTranslation } from 'react-i18next';

export const EmptyTable = (props: {
  text: string,
  searchTerm?: string,
  onClear: () => void,
  onAdd: () => void,
  addItemText: string,
  onAddIsCreating: boolean,
  onAddIsDisabled?: boolean,
  headerHeight?: number,
  bodyRowHeight?: number,
  showOnAdd?: boolean,
  withPaginationShown?: boolean;
  showClear?: boolean;
  showSecondaryText?: boolean;
}) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  const willShowOnAdd = (props.showOnAdd == undefined) || (props.showOnAdd == true);
  const willShowOnPagination = ((props.withPaginationShown == undefined) || (props.withPaginationShown == true));
  const willshowClear = ((props.showClear == undefined) || (props.showClear == true));
  const willshowSecondaryText = ((props.showSecondaryText == undefined) || (props.showSecondaryText == true));

  return <Box sx={{
    borderColor: theme.palette.custom.gray[300],
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  }}>
    <Box sx={{
      height: `${49 + (willShowOnPagination ? 60 : 0) + (props.headerHeight ?? 55) + ((props.bodyRowHeight ?? 45) * 10)}px`,
      display: 'flex',
      flexDirection: 'column', // Align children in a vertical column
      alignItems: 'center',    // Horizontally center the children
      width: '100%',           // Full width of the parent container
    }}>
      <Box
        sx={{
          height: `${49 + (willShowOnPagination ? 60 : 0) + (props.headerHeight ?? 55) + ((props.bodyRowHeight ?? 45) * 10)}px`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center', // Center children vertically
          alignItems: 'center', // Center children horizontally
          width: '100%',
          borderBottom: `${willShowOnPagination ? 1 : 0}px solid`,
          borderColor: theme.palette.custom.gray[300],
        }}
      >
        <Box sx={{ mb: 4 }}>
          <Box
            sx={{
              minWidth: '48px',
              minHeight: '48px',
              border: '1px solid',
              borderRadius: '10px',
              borderColor: theme.palette.custom.gray[300],
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 1px 2px 1px #1018280D',
            }}
          >
            <SvgIcon>
              <SearchSm />
            </SvgIcon>
          </Box>
        </Box>
        <Box>
          <Typography variant="textMD"
            fontWeight="600">
            {t('emptyTableTitle',
              {
                itemName: props.text,
              })}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center', mb: 4 }}>
          {willshowSecondaryText && <Typography variant="textSM"
            color={theme.palette.custom.gray[600]}
            fontWeight={400}>
            {t('emptyTableText',
              {
                searchTerm: props.searchTerm ? `"${props.searchTerm}" ` : '',
                itemName: props.text,
              })}
          </Typography>}
        </Box>
        <Box>
          <Stack spacing={3}
            direction={{ xs: 'column', md: 'row' }}>
            {willshowClear && <Button onClick={props.onClear}
              variant="secondary"
              size="md">
              {t('clearSearch')}
            </Button>}
            {willShowOnAdd && <Button onClick={props.onAdd}
              disabled={props.onAddIsCreating || props.onAddIsDisabled}
              startIcon={<SvgIcon><Plus fill="white" /></SvgIcon>}
              size="md">
              {props.addItemText}
            </Button>}
          </Stack>
        </Box>
      </Box>

      {((props.withPaginationShown === undefined) || (props.withPaginationShown === true)) && <CustomPagination setPage={() => { }}
        page={-1}
        maxPages={0}
        breakpointForChangeDisplay={120000}
        useNoDataMessage={false} />}
    </Box >

  </Box >;

};